export default __webpack_public_path__ + "static/media/start_Landing_Page_Wiffle.16ad3401.jpg";